module.exports = __webpack_public_path__ + "img/cc.189954f0.svg";